/**
 * Phase 2 — normalize verification queue items from gap-fill / discrepancies (client calls enqueue callable).
 */

/**
 * @param {object} item
 * @returns {string}
 */
export function ddxVerificationDedupeKey(item) {
  const snomed = item.snomedCode != null ? String(item.snomedCode) : '';
  const label = (item.normalizedLabel || item.label || '').toLowerCase().trim();
  const type = item.candidateType || 'diagnosis';
  return `${type}|${snomed}|${label}`;
}

/**
 * @param {object[]} items - queue-shaped partial docs
 * @returns {object[]}
 */
export function dedupeVerificationItems(items) {
  const map = new Map();
  for (const it of items) {
    const k = ddxVerificationDedupeKey(it);
    if (!map.has(k)) map.set(k, { ...it, independentGenerationCount: 1, generatingSessions: [...(it.generatingSessions || [])] });
    else {
      const cur = map.get(k);
      cur.independentGenerationCount = (cur.independentGenerationCount || 1) + 1;
      const sid = it.triggeringSessionId;
      if (sid && !(cur.generatingSessions || []).includes(sid)) {
        cur.generatingSessions = [...(cur.generatingSessions || []), sid];
      }
    }
  }
  return [...map.values()];
}
